import React from "react";
import { Container } from "reactstrap";
import { Transactions as TransactionsTable } from "../../Components/custom/TransactionsTable";

const Transactions = () => {
  document.title = "Sverka  | Bazaar";

  return (
    <div className="page-content">
      <Container fluid>
        <TransactionsTable />
      </Container>
    </div>
  );
};

export default Transactions;
